module.exports = __webpack_public_path__ + "static/img/tyLogo.d0866313.png";